import { useEffect, useState } from "react";

import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { useThemeBreakpoints } from "@/services/theme";

export const useInterventionMenuCard = () => {
  const { menuQuery } = useInterventionSectionContext();
  const [isVisible, setIsVisible] = useState(true);
  const { isSmallScreen } = useThemeBreakpoints();

  // Menu is in hover mode on small screens
  const isHoverMode = isSmallScreen;

  useEffect(() => {
    // Auto hide menu on small screen & show on large screen
    setIsVisible(!isHoverMode);
  }, [isHoverMode]);

  const onButtonClick = () => {
    if (isHoverMode) return;
    setIsVisible((value) => !value);
  };

  const onButtonMouseOver = () => {
    if (!isHoverMode) return;
    setIsVisible(true);
  };

  const onCardMouseLeave = () => {
    if (!isHoverMode) return;
    setIsVisible(false);
  };

  return {
    isLoading: menuQuery.isLoading,
    isVisible,
    isHoverMode,
    onButtonClick,
    onButtonMouseOver,
    onCardMouseLeave,
  };
};
